import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';


const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A28BFF'];

const InventoryCategoryPie = () => {
  const [data, setData] = useState<any[]>([]);
  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/analytics/stock-by-category`, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        setData(res.data);
      } catch (error) {
        console.error('Error fetching category pie data:', error);
      }
    };

    fetchData();
  }, [API]);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
		  <Pie
			data={data}
			dataKey="stock"
			nameKey="category"
			cx="50%"
			cy="50%"
			outerRadius={100}
			fill="#8884d8"
			label={({ value }) => `${value}`}
		  >
			{data.map((_, index) => (
			  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
			))}
		  </Pie>

		  <Tooltip
			content={({ active, payload }) => {
			  if (active && payload && payload.length) {
				const total = data.reduce((sum, d) => sum + d.stock, 0);
				const value = payload[0].value;
				const category = payload[0].name;
				const percent = ((value / total) * 100).toFixed(1);
				return (
				  <div className="bg-white p-2 shadow rounded text-sm border">
					<div><strong>{category}</strong></div>
					<div>{value} unit(s)</div>
					<div>{percent}%</div>
				  </div>
				);
			  }
			  return null;
			}}
		  />

		  <Legend />
		</PieChart>

    </ResponsiveContainer>
  );
};

export default InventoryCategoryPie;